
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLimitsImproving as ObiLimitsImprovingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-limits-improving.js';
 
 
 

 
 export const ObiLimitsImproving = createComponent({
   react: React,
   tagName: 'obi-limits-improving',
   elementClass: ObiLimitsImprovingElement,
   events: {
     
   }
  });
 
 